module.exports = __webpack_public_path__ + "media/images/sales/smakon/thumb-pricing-01-7cc9de7c0ecab19cbbad436ed462ddfb.svg";